/* unplugin-vue-components disabled */import script from "./preference-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./preference-dialog.vue?vue&type=script&lang=ts&setup=true"

import "./preference-dialog.vue?vue&type=style&index=0&id=11959edf&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11959edf"]])

export default __exports__